import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";
import type { Effect } from "../ir";

// Slow push-in with a long defocus. The trick is the LATE de-blur: at 60%
// we're still slightly out of focus, sells the "stepping into clarity"
// feeling. Reduced shadow intensity vs the previous version — 0.4 reads as
// "presence", 0.7 reads as "drop-shadow plugin from 2008".
export const cinematicZoom: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    effects: [
      { kind: "shadow" as Effect, intensity: 0.4 },
      ...ir.effects,
    ].slice(0, 4),
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeInOutCubic",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0,    scale: 1.35, filter: "blur(14px) brightness(1.1)" },
        { t: 0.35, opacity: 0.55, scale: 1.18, filter: "blur(8px) brightness(1.05)" },
        { t: 0.70, opacity: 1,    scale: 1.03, filter: "blur(1px) brightness(1)" },
        { t: 1.00, opacity: 1,    scale: 1,    filter: "blur(0px) brightness(1)" },
      ],
    }],
  };
};
